type RestrictionsListProps = {
  restrictions: string[]
}

const RestrictionsList = ({ restrictions }: RestrictionsListProps) => {
  return restrictions?.map((restriction) => (
    <p className="typography-body-l" key={restriction}>
      -&nbsp;{restriction}
    </p>
  ))
}

export default RestrictionsList
